import { useTranslation } from 'react-i18next'
import { AddPermissionForm } from 'src/pages/configuration/permissions/_components/permissions-form.component'
import { ConfigurationHeaderWrapper } from '../../_components/configuration-header-wrapper.component'

export default function AddPermissionPage() {
  const { t } = useTranslation()

  return (
    <ConfigurationHeaderWrapper
      title={t('pages.configuration.permissions.add-permission')}
      subTitle={t('pages.configuration.permissions.explanations')}
    >
      <AddPermissionForm />
    </ConfigurationHeaderWrapper>
  )
}
